var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0439 0.225302C16.3443 0.525706 16.3443 1.01276 16.0439 1.31316L7.35709 10L16.0439 18.6868C16.3443 18.9872 16.3443 19.4743 16.0439 19.7747C15.7435 20.0751 15.2565 20.0751 14.9561 19.7747L5.7253 10.5439C5.4249 10.2435 5.4249 9.75648 5.7253 9.45607L14.9561 0.225302C15.2565 -0.0751008 15.7435 -0.0751008 16.0439 0.225302Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPage);
export default __webpack_public_path__ + "static/media/previous_page.9670080f3a7b3d4eb4dbdbb7f6c07646.svg";
export { ForwardRef as ReactComponent };